export default {
	0: 'Augmenter niveau',
	1: 'Contrat',
	2: 'Mission',
	3: 'Onboard',
	4: 'Remboursement',
	45: 'Dates ne correspondent pas',
	5: 'Autre'
}